import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/alarm_notification_rules',
  component: Management,
  redirect: '/alarm_notification_rules/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/alarm_notification_rules/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listAlarmNotificationRules
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/alarm_notification_rules/ListTable'),
          meta: {
            auth: Auth.listAlarmNotificationRules,
            tabName: 'all'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/alarm_notification_rules/New'),
      meta: {
        auth: Auth.createAlarmNotificationRule
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/alarm_notification_rules/Edit'),
      meta: {
        auth: Auth.updateAlarmNotificationRule
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/alarm_notification_rules/DetailLayout'),
      meta: {
        auth: Auth.showAlarmNotificationRule
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/alarm_notification_rules/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showAlarmNotificationRule
          }
        }
      ]
    }
  ]
}
